import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import getParamsFromString from "../../../Utils/getParamsFromString";
import DOMPurify from "dompurify";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../Utils/lib";
import styled from "styled-components"

const StyledContainer = styled.div`${props => props.customStyles}`

const TextRender = (props) => {
    const {label, currentStyles, fromDesigner, globalValues, screenName, actionsContext} = props;
    const [value, setValue] = useState('');
    const userLanguage = useSelector(state => state.app.userLanguage);
    useEffect(() => {
        const multiLanguageLabel = multiLanguageValue(label, userLanguage) || '';
        let params = fromDesigner ?
            multiLanguageLabel :
            getParamsFromString(multiLanguageLabel, {...actionsContext, ...globalValues}, screenName, {}, true);
        if (params) {
            setValue(DOMPurify.sanitize(params))
        }
    }, [JSON.stringify({...globalValues, ...actionsContext}), userLanguage]);

    return (
        <StyledContainer
            customStyles={currentStyles.customStyles}
            className={'ql-editor'}
            style={{
                overflow: 'auto',
                width: currentStyles.width,
                height: currentStyles.height || 'auto',
                margin: currentStyles.margin,
                padding: currentStyles.padding || 1,
            }}
            dangerouslySetInnerHTML={{__html: fromDesigner ? multiLanguageValue(label, userLanguage) : value}}>
        </StyledContainer>
    )
};

export default TextRender

TextRender.propTypes = {
    value: PropTypes.string,
    currentStyles: PropTypes.object,
    fromDesigner: PropTypes.bool,
    globalValues: PropTypes.object,
    screenName: PropTypes.string,
};